import { faArrowLeft, faCheck } from "@fortawesome/free-solid-svg-icons";
import type { FC } from "react";
import type { Assessor } from "../api/dto";
import { Button } from "../components/form/Button";
import { useModalControls } from "../components/layout/ModalProvider";

/**
 * Warning (never a hard block) shown when the logged-in user isn't the assessor assigned to the inspection they're
 * about to fill in. Closing the modal (escape, backdrop, "Toch doorgaan") just continues on the page.
 */
export const OtherAssessorWarningModal: FC<{ assessor: Assessor; onBack: () => void }> = (
  props,
) => {
  const { close } = useModalControls();
  const name = `${props.assessor.first_name} ${props.assessor.last_name}`.trim();
  return (
    <div>
      <p>
        <strong>Let op!</strong> Deze inspectie is toegewezen aan assessor <strong>{name}</strong>,
        en dat ben jij niet.
      </p>
      <p className={"mt-2"}>Controleer of je de juiste inspectie invult voordat je doorgaat.</p>
      <footer
        className={
          "-mx-4 px-4 mt-3 py-3 border-t border-slate-100 flex items-center justify-between space-x-3"
        }
      >
        <Button
          type={"primary"}
          size={"md"}
          text={"Toch doorgaan"}
          icon={faCheck}
          onClick={() => close()}
        />
        <Button
          type={"secondary"}
          size={"md"}
          text={"Terug naar inspectie"}
          icon={faArrowLeft}
          onClick={() => {
            close();
            props.onBack();
          }}
        />
      </footer>
    </div>
  );
};
